tinymce.addI18n("bs", {
    "#": "#",
    "Accessibility": "Pristupa\u010dnost",
    "Accordion": "Harmonika",
    "Accordion body...": "Sadr\u017eaj harmonike...",
    "Accordion summary...": "Sa\u017eetak harmonike...",
    "Action": "Akcija",
    "Activity": "Aktivnost",
    "Address": "Adresa",
    "Advanced": "Napredno",
    "Align": "Poravnajte",
    "Align center": "Centriraj",
    "Align left": "Poravnaj lijevo",
    "Align right": "Poravnaj desno",
    "Alignment": "Poravnanje",
    "Alignment {0}": "Poravnanje {0}",
    "All": "Sve",
    "Alternative description": "Alternativni opis",
    "Alternative source": "Alternativni izvor",
    "Alternative source URL": "URL alternativnog izvora",
    "Anchor": "Veza",
    "Anchor...": "Veza...",
    "Anchors": "Veze",
    "Animals and Nature": "\u017divotinje i Priroda",
    "Arrows": "Strelice",
    "B": "B",
    "Background color": "Boja pozadine",
    "Background color {0}": "Boja pozadine {0}",
    "Black": "Crna",
    "Block": "Blok",
    "Block {0}": "Blok {0}",
    "Blockquote": "Blok citat",
    "Blocks": "Blokovi",
    "Blue": "Plava",
    "Blue component": "Plava komponenta",
    "Body": "Tijelo",
    "Bold": "Podebljano",
    "Border": "Okvir",
    "Border color": "Boja okvira",
    "Border style": "Stil okvira",
    "Border width": "\u0160irina okvira",
    "Bottom": "Dno",
    "Browse files": "Pregled datoteka",
    "Browse for an image": "Pregledaj slike",
    "Browse links": "Pregled veza",
    "Bullet list": "Bullet lista",
    "Cancel": "Otka\u017ei",
    "Caption": "Natpis",
    "Cell": "\u0106elija",
    "Cell padding": "Ispunjenje \u0107elije",
    "Cell properties": "Svojstva \u0107elije",
    "Cell spacing": "Razmak \u0107elija",
    "Cell styles": "Stilovi c\u0301elija",
    "Cell type": "Vrsta \u0107elije",
    "Center": "Centrirano",
    "Characters": "Karakteri",
    "Characters (no spaces)": "Karakteri (bez razmaka)",
    "Circle": "Krug",
    "Class": "Klasa",
    "Clear formatting": "Poni\u0161ti formatiranje",
    "Close": "Zatvori",
    "Code": "Kod",
    "Code sample...": "Uzorak koda...",
    "Code view": "Prikaz koda",
    "Color Picker": "Bira\u010d boja",
    "Color swatch": "Uzorak boja",
    "Cols": "Kolone",
    "Column": "Kolona",
    "Column clipboard actions": "Radnje me\u0111uspremnika kolone",
    "Column group": "Grupa kolone",
    "Column header": "Zaglavlje kolone",
    "Constrain proportions": "Ograni\u010di proporcije",
    "Copy": "Kopiraj",
    "Copy column": "Kopirajte kolonu",
    "Copy row": "Kopiraj red",
    "Could not find the specified string.": "Tra\u017eeni string nije prona\u0111en.",
    "Could not load emojis": "Nije moguc\u0301e u\u010ditati emod\u017eije",
    "Count": "Prebroji",
    "Currency": "Valuta",
    "Current window": "Trenutni prozor",
    "Custom color": "Korisni\u010dka boja",
    "Custom...": "Prilago\u0111eno...",
    "Cut": "Izre\u017ei",
    "Cut column": "Isije\u010dite kolonu",
    "Cut row": "Izre\u017ei red",
    "Dark Blue": "Tamno plava",
    "Dark Gray": "Tamno siva",
    "Dark Green": "Tamno zelena",
    "Dark Orange": "Tamno narand\u017easta",
    "Dark Purple": "Tamno ljubi\u010dasta",
    "Dark Red": "Tamno crvena",
    "Dark Turquoise": "Tamno tirkizna",
    "Dark Yellow": "Tamno \u017euta",
    "Dashed": "Crti\u010dasto",
    "Date/time": "Datum/vrijeme",
    "Decrease indent": "Smanji uvlaku",
    "Default": "Po\u010detno",
    "Delete accordion": "Obri\u0161i harmoniku",
    "Delete column": "Obri\u0161i kolonu",
    "Delete row": "Obri\u0161i red",
    "Delete table": "Obri\u0161i tabelu",
    "Dimensions": "Dimenzije",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "Ta\u010dkasto",
    "Double": "Duplo",
    "Drop an image here": "Otpusti sliku ovdje",
    "Dropped file type is not supported": "Tip prilo\u017eenog fajla nije podr\u017ean",
    "Edit": "Uredi",
    "Embed": "Ugradi",
    "Emojis": "Emod\u017eije",
    "Emojis...": "Emod\u017eije...",
    "Error": "Gre\u0161ka",
    "Error: Form submit field collision.": "Gre\u0161ka: Sukob polja za slanje forme.",
    "Error: No form element found.": "Gre\u0161ka: Nije prona\u0111en nijedan element forme.",
    "Extended Latin": "Pro\u0161irena latinica",
    "Failed to initialize plugin: {0}": "Neuspje\u0161no inicijalizovanje dodatka: {0}",
    "Failed to load plugin url: {0}": "Neuspje\u0161no u\u010ditavanje url-a dodatka: {0}",
    "Failed to load plugin: {0} from url {1}": "Neuspje\u0161no u\u010ditavanje dodatka: {0} sa url-a {1}",
    "Failed to upload image: {0}": "Neuspje\u0161no otpremanje slike: {0}",
    "File": "Datoteka",
    "Find": "Prona\u0111i",
    "Find (if searchreplace plugin activated)": "Prona\u0111ite (ako je dodatak za pretragu i zamjenu aktiviran)",
    "Find and Replace": "Prona\u0111ite i Zamijenite",
    "Find and replace...": "Prona\u0111ite i zamijenite...",
    "Find in selection": "Prona\u0111i u odabiru",
    "Find whole words only": "Prona\u0111i samo cijele rije\u010di",
    "Flags": "Zastave",
    "Focus to contextual toolbar": "Fokusirajte na kontekstualnu alatnu traku",
    "Focus to element path": "Fokusirajte na putanju elementa",
    "Focus to menubar": "Fokusirajte na traku menija",
    "Focus to toolbar": "Fokusirajte na alatnu traku",
    "Font": "Font",
    "Font size {0}": "Veli\u010dina slova {0}",
    "Font sizes": "Veli\u010dina fonta",
    "Font {0}": "Font {0}",
    "Fonts": "Fontovi",
    "Food and Drink": "Hrana i Pi\u0107a",
    "Footer": "Podno\u017eje",
    "Format": "Formatiranje",
    "Format {0}": "Formatiranje {0}",
    "Formats": "Formati",
    "Fullscreen": "Cijeli ekran",
    "G": "G",
    "General": "Op\u0107enito",
    "Gray": "Siva",
    "Green": "Zelena",
    "Green component": "Zelena komponenta",
    "Groove": "Udubljeno",
    "Handy Shortcuts": "Korisne pre\u010dice",
    "Header": "Zaglavlje",
    "Header cell": "\u0106elija zaglavlja",
    "Heading 1": "Naslov 1",
    "Heading 2": "Naslov 2",
    "Heading 3": "Naslov 3",
    "Heading 4": "Naslov 4",
    "Heading 5": "Naslov 5",
    "Heading 6": "Naslov 6",
    "Headings": "Naslovi",
    "Height": "Visina",
    "Help": "Pomo\u0107",
    "Hex color code": "Heksadecimalni kod boje",
    "Hidden": "Skriveno",
    "Horizontal align": "Vodoravna linija",
    "Horizontal line": "Vodoravna linija",
    "Horizontal space": "Horizontalni razmak",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID treba po\u010deti slovom, a nakon toga mo\u017ee sadr\u017eavati samo slova, brojeve, crte, ta\u010dke, dvota\u010dke ili donje crte.",
    "Image is decorative": "Slika je dekorativna",
    "Image list": "Lista slika",
    "Image title": "Naslov slike",
    "Image...": "Slika...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Gre\u0161ka ImageProxy HTTP: Nije prona\u0111en Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Gre\u0161ka ImageProxy HTTP: Neispravan URL Image Proxyja",
    "ImageProxy HTTP error: Rejected request": "Gre\u0161ka ImageProxy HTTP: Zahtjev odbijen",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Gre\u0161ka ImageProxy HTTP: Nepoznata gre\u0161ka ImageProxyja",
    "Increase indent": "Pove\u0107aj uvlaku",
    "Inline": "U liniji",
    "Insert": "Umetni",
    "Insert Template": "Ubaci \u0160ablon",
    "Insert accordion": "Dodajte harmoniku",
    "Insert column after": "Umetni kolonu ispod",
    "Insert column before": "Umetni kolonu iznad",
    "Insert date/time": "Umetni datum/vrijeme",
    "Insert image": "Umetni sliku",
    "Insert link (if link plugin activated)": "Ubacite vezu (ako je dodatak za veze aktiviran)",
    "Insert row after": "Umetni red ispod",
    "Insert row before": "Umetni red iznad",
    "Insert table": "Umetni tabelu",
    "Insert template...": "Ubaci \u0161ablon...",
    "Insert video": "Umetni video",
    "Insert/Edit code sample": "Ubaci/Uredi uzorak koda",
    "Insert/edit image": "Umetni/uredi sliku",
    "Insert/edit link": "Umetni/uredi link",
    "Insert/edit media": "Ubacite/uredite medij",
    "Insert/edit video": "Umetni/uredi video",
    "Inset": "Uvu\u010deno",
    "Invalid hex color code: {0}": "Neispravan heksadecimalni kod boje: {0}",
    "Invalid input": "Neva\u017eec\u0301i unos",
    "Italic": "Nakrivljeno",
    "Justify": "Obostrano poravnanje",
    "Keyboard Navigation": "Navigacija tastaturom",
    "Language": "Jezik",
    "Learn more...": "Saznajte vi\u0161e...",
    "Left": "Lijevo",
    "Left to right": "S lijeva na desno",
    "Light Blue": "Svijetlo plava",
    "Light Gray": "Svijetlo siva",
    "Light Green": "Svijetlo zelena",
    "Light Purple": "Svijetlo ljubi\u010dasta",
    "Light Red": "Svijetlo crvena",
    "Light Yellow": "Svijetlo \u017euta",
    "Line height": "Visina linije",
    "Link list": "Lista linkova",
    "Link...": "Link...",
    "List Properties": "Svojstva Liste",
    "List properties...": "Svojstva liste...",
    "Loading emojis...": "U\u010ditavanje emod\u017eija...",
    "Loading...": "U\u010ditavanje...",
    "Lower Alpha": "Mala slova",
    "Lower Greek": "Mala gr\u010dka slova",
    "Lower Roman": "Mala rimska slova",
    "Match case": "Razlikuj mala i velika slova",
    "Mathematical": "Matemati\u010dki",
    "Media poster (Image URL)": "Medijski poster (URL slike)",
    "Media...": "Medija...",
    "Medium Blue": "Srednje plava",
    "Medium Gray": "Srednje siva",
    "Medium Purple": "Srednje ljubi\u010dasta",
    "Merge cells": "Spoji \u0107elije",
    "Middle": "Sredina",
    "Midnight Blue": "Pono\u0107no plava",
    "More...": "Vi\u0161e...",
    "Name": "Ime",
    "Navy Blue": "Navi Plava",
    "New document": "Novi dokument",
    "New window": "Novi prozor",
    "Next": "Sljede\u0107e",
    "No": "Ne",
    "No alignment": "Bez poravnanja",
    "No color": "Bez boje",
    "Nonbreaking space": "Neprekidni razmak",
    "None": "Ni\u0161ta",
    "Numbered list": "Numerisana lista",
    "OR": "ILI",
    "Objects": "Objekti",
    "Ok": "U redu",
    "Open help dialog": "Otvori dijalog pomo\u0107i",
    "Open link": "Otvorite link",
    "Open link in...": "Otvorite link u...",
    "Open popup menu for split buttons": "Otvori iska\u010duc\u0301i meni za podeljena dugmad",
    "Orange": "Narand\u017easta",
    "Outset": "Izvu\u010deno",
    "Page break": "Prijelom stranice",
    "Paragraph": "Paragraf",
    "Paste": "Zalijepi",
    "Paste as text": "Zalijepi kao tekst",
    "Paste column after": "Zalijepi kolonu poslije",
    "Paste column before": "Zalijepi kolonu prije",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Zalijepljenje je sada u obi\u010dnom tekstualnom modu. Sadr\u017eaj \u0107e biti zalijepljen kao obi\u010dni tekst sve dok ne isklju\u010dite ovu opciju.",
    "Paste or type a link": "Nalepite ili otkucajte link",
    "Paste row after": "Zalijepi red iznad",
    "Paste row before": "Zalijepi red ispod",
    "Paste your embed code below:": "Zalijepite va\u0161 ugradbeni kod ispod:",
    "People": "Ljudi",
    "Plugins": "Dodaci",
    "Plugins installed ({0}):": "Instalirani dodaci ({0}):",
    "Powered by {0}": "Omogu\u0107eno od {0}",
    "Pre": "Pre",
    "Preferences": "Preference",
    "Preformatted": "Preformatirano",
    "Premium plugins:": "Premijum dodaci:",
    "Press the Up and Down arrow keys to resize the editor.": "Pritisnite tastere sa strelicama gore i dolje za promjenu veli\u010dine ure\u0111iva\u010da.",
    "Press the arrow keys to resize the editor.": "Pritisnite tastere sa strelicama za promjenu veli\u010dine ure\u0111iva\u010da.",
    "Press {0} for help": "Pritisnite {0} za pomo\u0107",
    "Preview": "Pregled",
    "Previous": "Prethodni",
    "Print": "Od\u0161tampajte",
    "Print...": "Od\u0161tampajte...",
    "Purple": "Ljubi\u010dasta",
    "Quotations": "Citati",
    "R": "R",
    "Range 0 to 255": "Raspon od 0 do 255",
    "Red": "Crvena",
    "Red component": "Crvena komponenta",
    "Redo": "Naprijed",
    "Remove": "Uklonite",
    "Remove color": "Uklonite boju",
    "Remove link": "Ukloni link",
    "Replace": "Zamijeni",
    "Replace all": "Zamijeni sve",
    "Replace with": "Zamijenite sa",
    "Resize": "Promijenite veli\u010dinu",
    "Restore last draft": "Vrati posljednju skicu",
    "Reveal or hide additional toolbar items": "Prika\u017ei ili sakrij dodatne stavke alatne trake",
    "Rich Text Area": "Rich tekst oblast",
    "Rich Text Area. Press ALT-0 for help.": "Rich tekst oblast. Pritisnite ALT-0 za pomo\u0107.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Oblast za ure\u0111ivanje teksta. Pritisnite ALT-F9 za meni. Pritisnite ALT-F10 za prikaz alatne trake. Pritisnite ALT-0 za pomo\u0107",
    "Ridge": "Izdignuto",
    "Right": "Desno",
    "Right to left": "S desna na lijevo",
    "Row": "Red",
    "Row clipboard actions": "Radnje sa redom iz me\u0111uspremnika",
    "Row group": "Grupa reda",
    "Row header": "Zaglavlje reda",
    "Row properties": "Svojstva reda",
    "Row type": "Vrsta reda",
    "Rows": "Redovi",
    "Save": "Sa\u010duvaj",
    "Save (if save plugin activated)": "Sa\u010duvajte (ako je dodatak za \u010duvanje aktiviran)",
    "Scope": "Opseg",
    "Search": "Pretra\u017eite",
    "Select all": "Ozna\u010di sve",
    "Select...": "Odaberite...",
    "Selection": "Selekcija",
    "Shortcut": "Pre\u010dica",
    "Show blocks": "Prika\u017ei blokove",
    "Show caption": "Prika\u017ei naslov",
    "Show invisible characters": "Prika\u017ei nevidljive znakove",
    "Size": "Veli\u010dina",
    "Solid": "Puna",
    "Source": "Izvor",
    "Source code": "Izvorni kod",
    "Special Character": "Specijalni Karakteri",
    "Special character...": "Specijalni karakteri...",
    "Split cell": "Podijeli \u0107eliju",
    "Square": "Kvadrat",
    "Start list at number": "Po\u010detna lista na broju",
    "Strikethrough": "Precrtano",
    "Style": "Stil",
    "Subscript": "Indeks",
    "Superscript": "Eksponent",
    "Switch to or from fullscreen mode": "Prebaci u ili iz re\u017eima preko cijelog ekrana",
    "Symbols": "Simboli",
    "System Font": "Sistemski font",
    "Table": "Tabela",
    "Table caption": "Naslov tabele",
    "Table properties": "Svojstva tabele",
    "Table styles": "Stil tabele",
    "Template": "\u0160ablon",
    "Templates": "Predlo\u0161ci",
    "Text": "Tekst",
    "Text color": "Boja tekst",
    "Text color {0}": "Boja teksta {0}",
    "Text to display": "Tekst za prikaz",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Izgleda da je URL koji ste upisali ustvari email adresa. \u017delite li da dodate obavezni mailto: prefiks?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Izgleda je URL koji ste upisali vanjski link. \u017delite li da dodate obavezni http:// prefiks?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Izgleda da je URL koji ste uneli spoljna veza. Da li \u017eelite da dodate potreban prefiks https://?",
    "Title": "Naslov",
    "To open the popup, press Shift+Enter": "Za otvaranje iska\u010du\u0107eg prozora, pritisnite Shift+Enter",
    "Toggle accordion": "Prebacite harmoniku",
    "Tools": "Alati",
    "Top": "Vrh",
    "Travel and Places": "Putovanje i Mjesta",
    "Turquoise": "Tirkizna",
    "Underline": "Podvu\u010deno",
    "Undo": "Nazad",
    "Upload": "Otpremi",
    "Uploading image": "Otpremanje slike",
    "Upper Alpha": "Velika slova",
    "Upper Roman": "Velika rimska slova",
    "Url": "Url",
    "User Defined": "Definisano od strane korisnika",
    "Valid": "Validno",
    "Version": "Verzija",
    "Vertical align": "Vertikalno poravnanje",
    "Vertical space": "Vertikalni razmak",
    "View": "Pregled",
    "Visual aids": "Vizuelna pomo\u0107",
    "Warn": "Upozorenje",
    "White": "Bijela",
    "Width": "\u0160irina",
    "Word count": "Broj rije\u010di",
    "Words": "Rije\u010di",
    "Words: {0}": "Rije\u010di: {0}",
    "Yellow": "\u017duta",
    "Yes": "Da",
    "You are using {0}": "Koristite {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Niste sa\u010duvali izmjene. Jeste li sigurni da \u017eelite napustiti stranicu?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Va\u0161 pretra\u017eiva\u010d ne podr\u017eava direktan pristup me\u0111umemoriji. Molimo vas da koristite pre\u010dice Ctrl+X/C/V na tastaturi.",
    "alignment": "poravnanje",
    "austral sign": "austral znak",
    "cedi sign": "cedi znak",
    "colon sign": "boja znak",
    "cruzeiro sign": "cruzeiro znak",
    "currency sign": "valuta znak",
    "dollar sign": "dolar znak",
    "dong sign": "dong znak",
    "drachma sign": "drachma znak",
    "euro-currency sign": "euro valuta znak",
    "example": "primjer",
    "formatting": "formatiranje",
    "french franc sign": "francuski frank znak",
    "german penny symbol": "njema\u010dki peni simbol",
    "guarani sign": "guarani znak",
    "history": "istorija",
    "hryvnia sign": "hryvnia znak",
    "indentation": "uvla\u010denje",
    "indian rupee sign": "indijska rupija znak",
    "kip sign": "kip znak",
    "lira sign": "lira znak",
    "livre tournois sign": "livr turnoa znak",
    "manat sign": "manat znak",
    "mill sign": "mlin znak",
    "naira sign": "naira znak",
    "new sheqel sign": "novi \u0161ekela znak",
    "nordic mark sign": "nordijski znak",
    "peseta sign": "preseta znak",
    "peso sign": "peso znak",
    "ruble sign": "rublje znak",
    "rupee sign": "ruplja znak",
    "spesmilo sign": "spesmilo znak",
    "styles": "stilovi",
    "tenge sign": "tenge znak",
    "tugrik sign": "tugrik znak",
    "turkish lira sign": "turska lira znak",
    "won sign": "von znak",
    "yen character": "jen znak",
    "yen/yuan character variant one": "varijanta jedan karaktera jen/juan",
    "yuan character": "juan znak",
    "yuan character, in hong kong and taiwan": "juan, u Hong Kongu i Tajvanu",
    "{0} characters": "{0} karaktera",
    "{0} columns, {1} rows": "{0} kolona, {1} redova",
    "{0} words": "{0} rije\u010di"
});